import { z } from "zod";

const envSchema = z.object({
  oidcAuthority: z.string(),
  oidcClientId: z.string(),
  appUrl: z.string(),
  appBasePath: z.string(), // brukes som /kundeportal eller /selskapsportal lokalt, mens er "/" i andre miljø
  appSelskapsportalUrl: z.string(),
  apiUrl: z.string(),
  isDebug: z.boolean(),
  mode: z.enum(["development", "production"]),
  // TODO password: Fjern når passordbeskyttelse ikke er nødvendig lenger
  appPassword: z
    .string()
    .transform((val) => {
      if (val === "$(VITE_APP_PASSWORD)" || val.length === 0) {
        return undefined;
      }
      return val;
    })
    .optional(),
  sentryUrl: z.string().optional(),
  appInsightsConnectionString: z.string().optional(),
});

const buildEnv = () => {
  const envVariables = {
    oidcAuthority:
      import.meta.env.VITE_OIDC_AUTHORITY || window.config.VITE_OIDC_AUTHORITY,
    oidcClientId:
      import.meta.env.VITE_OIDC_CLIENT_ID || window.config.VITE_OIDC_CLIENT_ID,
    appUrl:
      (import.meta.env.VITE_APP_URL || window.config.VITE_APP_URL) ??
      window.location.origin,
    appBasePath:
      (import.meta.env.VITE_APP_BASE_PATH ||
        window.config.VITE_APP_BASE_PATH) ??
      "/", // brukes som /kundeportal eller /selskapsportal lokalt, mens er "/" i andre miljø
    apiUrl: import.meta.env.VITE_API_URL || window.config?.VITE_API_URL,
    appSelskapsportalUrl:
      import.meta.env.VITE_APP_SELSKAPSPORTAL_URL ||
      window.config?.VITE_APP_SELSKAPSPORTAL_URL,
    appPassword:
      import.meta.env.VITE_APP_PASSWORD || window.config?.VITE_APP_PASSWORD,
    sentryUrl:
      import.meta.env.VITE_SENTRY_URL || window.config?.VITE_SENTRY_URL,
    appInsightsConnectionString:
      import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ||
      window.config?.VITE_APPINSIGHTS_CONNECTION_STRING,
    isDebug:
      import.meta.env.VITE_IS_DEBUG === "true" ||
      window.config?.VITE_IS_DEBUG === "true",
    mode: import.meta.env.MODE || window.config.MODE,
  };
  if (import.meta.env.VITE_SKIP_ENV_VALIDATION) {
    return envVariables;
  }
  return envSchema.parse(envVariables);
};

export const env = buildEnv();

export type ClientEnv = z.infer<typeof envSchema>;
